import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";

import { Enquiry } from "./enquiry.model";
import { EnquiryOptions } from "./enquiry-options.model";
import { RepaymentCalculation } from "./repayment-calculation.model";
import { RepaymentOption } from "./repayment-option.model";
import { handleError } from "./handle-error";

@Injectable()
export class EnquiryService {
    private enquiriesUrl = "introducer-api/enquiries";  // url to web api

    constructor(private http: HttpClient) { }

    getRepaymentOptions(token: string, calcParams: RepaymentCalculation): Observable<RepaymentOption[]> {
        return this.http.post(`${this.enquiriesUrl}/repayments`, calcParams, {
            params: new HttpParams()
                .set("token", (token != null) ? token : "")
        })
        .pipe(catchError(handleError));
    }

    getOptions(token: string): Promise<EnquiryOptions> {
        const url = `${this.enquiriesUrl}/options`;
        return this.http.get<EnquiryOptions>(url, {
            params: new HttpParams()
                .set("token", (token != null) ? token : "")
            })
            .toPromise()
            .catch(handleError);
    }

    submit(token: string, enq: Enquiry): Promise<Enquiry> {
        return this.http.post(`${this.enquiriesUrl}/submit`, enq, {
            params: new HttpParams()
                .set("token", (token != null) ? token : "")
            })
            .toPromise()
            .catch(handleError);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/shared/enquiry.service.ts